type FacetList = readonly ({
    readonly facetField: string | null;
    readonly facetValues:
        | readonly ({ readonly count: number | null; readonly value: string | null } | null)[]
        | null;
} | null)[];

/** example facet list
```
 [
     {
         facetField: 'auctionStatus';
         facetValues: [..., { value: 'ITEM_SEARCH_AUCTION_UPCOMING'; count: 4 }];
     },
     {
         facetField: 'auctionMarketType';
         facetValues: [..., { value: 'ITEM_SEARCH_MARKET_SECONDARY'; count: 12 }];
     }
 ];
 ```
 */
export const makeSearchFacetCountGetter =
    (facets: FacetList | null | undefined) =>
    (facetValue: string): number | null => {
        for (const facet of facets || []) {
            for (const _facetValue of facet?.facetValues || []) {
                if (_facetValue?.value === facetValue) {
                    return _facetValue.count;
                }
            }
        }
        return null;
    };

export const getSecondaryMarketCount = (facets: FacetList | null | undefined): number | null =>
    makeSearchFacetCountGetter(facets)('ITEM_SEARCH_MARKET_SECONDARY');
